import api from '../../../api';

export const createGeneralSchedule = async (data) => {
  try {
    const response = await api.post('/crm/general-schedules', data);
    return response.data;
  } catch (error) {
    console.error('Error creating general schedule:', error);
    throw error;
  }
};

export const getGeneralSchedules = async (scope) => {
  try {
    const response = await api.get('/crm/general-schedules', { params: scope ? { scope } : undefined });
    return response.data;
  } catch (error) {
    console.error('Error fetching general schedules:', error);
    throw error;
  }
};

export const updateGeneralSchedule = async (id, data) => {
  try {
    const response = await api.put(`/crm/general-schedules/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating general schedule:', error);
    throw error;
  }
};

export const deleteGeneralSchedule = async (id) => {
  try {
    const response = await api.delete(`/crm/general-schedules/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting general schedule:', error);
    throw error;
  }
};
